module.exports = __webpack_public_path__ + "05360fd1c574173932fe19d15f749d2f.pdf";